import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contentId", "lessonId", "language", "trackId"],
  _excluded2 = ["shortId", "language"],
  _excluded3 = ["shortId"];
import enviro from 'enviro';
import { KOALA } from 'HubStyleTokens/colors';
import Raven from 'raven-js';
import I18n from 'I18n';
import { useCallback } from 'react';
import UIImage from 'UIComponents/image/UIImage';
import { Metrics } from '../../../Metrics';
import { useVideo } from '../videoQueries';
import { useShortVideo } from '../../shortContent';

/*
HS video requires region prop to render videos that are not for the same reason as that of the creator's portal ID.
without the region prop, if the video uploader's portal ID is in NA1, the video won't render in EU1 and vice versa.
*/
import { jsx as _jsx } from "react/jsx-runtime";
export const HS_PROFESSOR_HUBLET = 'na1';
const EmbeddedVideoBase = ({
  autoPlay,
  onFinish,
  onPlay,
  onProgress,
  onReady,
  onLoaded,
  onClick,
  captionsOnByDefault,
  mutedByDefault,
  playSpeed,
  fallbackThumbnailUrl,
  videoType,
  videoId,
  creatorHubId,
  PlayerComponent,
  keyValue,
  currentTime
}) => {
  const playbackRate = playSpeed && playSpeed / 100;
  const onVideoLoaded = useCallback(() => {
    if (videoType === 'HUBSPOT_VIDEO') {
      Metrics.counter('hs-video-rendered-successfully').increment();
    }
    if (onLoaded) onLoaded();
  }, [onLoaded, videoType]);
  const hsVideoOnError = useCallback(e => {
    if (videoType === 'HUBSPOT_VIDEO') {
      Metrics.counter('hs-video-failed-to-render').increment();
      Raven.captureException(new Error('HS_VIDEO_FAILED_RENDER'), {
        extra: {
          videoId,
          creatorHubId,
          errorType: e.detail.errorType,
          errorPayload: e.detail.payload
        }
      });
    }
  }, [creatorHubId, videoId, videoType]);
  return videoId ? /*#__PURE__*/_jsx(PlayerComponent, {
    autoPlay: autoPlay,
    captionsOnByDefault: captionsOnByDefault,
    currentTime: currentTime,
    env: enviro.isQa() ? 'qa' : 'prod',
    loadingBackground: KOALA,
    mutedByDefault: mutedByDefault,
    onCLick: onClick,
    onError: hsVideoOnError,
    onFinish: onFinish,
    onLoaded: onVideoLoaded,
    onPlay: onPlay,
    onReady: onReady,
    onUpdateProgress: onProgress,
    playbackRate: playbackRate,
    portalId: creatorHubId,
    preload: "auto",
    region: HS_PROFESSOR_HUBLET,
    videoId: videoId,
    videoPlaySpeed: playSpeed
  }, keyValue) : /*#__PURE__*/_jsx(UIImage, {
    alt: I18n.text('learningCenter.overviewModal.thumbnail'),
    "data-test-id": "fallback-thumbnail",
    src: fallbackThumbnailUrl || undefined
  });
};
const EmbeddedVideoTrackLesson = _ref => {
  let {
      contentId,
      lessonId,
      language,
      trackId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const videoProps = useVideo({
    contentId,
    lessonId,
    trackId,
    language
  });
  if (!videoProps) return null;
  return /*#__PURE__*/_jsx(EmbeddedVideoBase, Object.assign({
    keyValue: contentId
  }, videoProps, props));
};
const EmbeddedVideoShort = _ref2 => {
  let {
      shortId,
      language
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const videoProps = useShortVideo({
    shortId: shortId,
    language
  });
  if (!videoProps) return null;
  return /*#__PURE__*/_jsx(EmbeddedVideoBase, Object.assign({
    keyValue: shortId.toString()
  }, videoProps, props));
};
export const EmbeddedVideo = _ref3 => {
  let {
      shortId
    } = _ref3,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  if (shortId) return /*#__PURE__*/_jsx(EmbeddedVideoShort, Object.assign({
    shortId: shortId
  }, props));else return /*#__PURE__*/_jsx(EmbeddedVideoTrackLesson, Object.assign({}, props));
};
export default EmbeddedVideo;